import React from 'react';
import './RouteCompletionStatus.css';

const RouteCompletionStatus = ({ 
  completionStop, 
  completionTime,
  onRestartRoute 
}) => {
  return (
    <div className="route-completion-status">
      <div className="completion-header">
        <div className="completion-icon">✅</div>
        <h2>Route Completed</h2>
      </div>
      
      <div className="completion-details">
        <p>
          Your route was completed at <strong>{completionStop?.Name || 'Unknown Stop'}</strong>
        </p>
        <p>
          Completion time: <strong>{completionTime}</strong>
        </p>
      </div>
      
      <div className="completion-instructions">
        <div className="instruction-item">
          <span className="instruction-icon">🚗</span>
          <span>Please return to the lot</span>
        </div>
        <div className="instruction-item">
          <span className="instruction-icon">📋</span>
          <span>Complete any required paperwork</span>
        </div>
      </div>
      
      <div className="completion-actions">
        <button 
          className="btn-restart-route"
          onClick={onRestartRoute}
        >
          Restart Route
        </button>
      </div>
      
      <div className="completion-note">
        <p>
          <strong>Note:</strong> If you need to continue the route, click "Restart Route" 
          to resume from where you left off.
        </p>
      </div>
    </div>
  );
};

export default RouteCompletionStatus;
